module.exports = __webpack_public_path__ + "img/health-care-section-1-image.72526879.png";